import { render } from "./Agenda.vue?vue&type=template&id=fcb69f7a&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=ts"
export * from "./Agenda.vue?vue&type=script&lang=ts"

import "./Agenda.vue?vue&type=style&index=0&id=fcb69f7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fcb69f7a"

export default script